import React, { Component } from 'react';
import { CheckCircle, Lock, AlertCircle } from 'lucide-react';
type CardStatus = 'locked' | 'available' | 'in_progress' | 'completed' | 'flagged' | 'skipped';
interface SummaryCardProps {
  title: string;
  icon: ComponentType<{
    className?: string;
  }>;
  status: CardStatus;
  isActive?: boolean;
  isRecentlyUpdated?: boolean;
  onViewLegal?: () => void;
  children: ReactNode;
}
export function SummaryCard({
  title,
  icon: Icon,
  status,
  isActive = false,
  isRecentlyUpdated = false,
  onViewLegal,
  children
}: SummaryCardProps) {
  const getCardStyles = () => {
    if (isRecentlyUpdated) {
      return 'border-violetBlue shadow-lg ring-2 ring-violetBlue/30 scale-[1.01]';
    }
    if (isActive) {
      return 'border-violetBlue shadow-md ring-1 ring-violetBlue/20 scale-[1.02]';
    }
    if (status === 'flagged') {
      return 'border-amber-400 shadow-sm';
    }
    if (status === 'completed') {
      return 'border-borderColor shadow-sm';
    }
    if (status === 'locked') {
      return 'opacity-40 border-borderColor';
    }
    if (status === 'skipped') {
      return 'border-dashed border-borderColor opacity-50';
    }
    return 'border-borderColor shadow-sm';
  };
  const getIconContainerStyles = () => {
    if (status === 'completed') return 'bg-turquoise/10 text-turquoise';
    if (status === 'flagged') return 'bg-amber-50 text-amber-600';
    if (status === 'locked' || status === 'skipped') return 'bg-gray-100 text-secondary';
    return 'bg-aliceBlue text-violetBlue';
  };
  return <div className={`bg-white p-4 sm:p-6 rounded-xl border-[0.5px] transition-all duration-500 ${getCardStyles()}`} data-id="element-1194">
      <div className="flex items-center justify-between mb-4" data-id="element-1195">
        <div className="flex items-center gap-3" data-id="element-1196">
          <div className={`p-2 rounded-lg ${getIconContainerStyles()}`} data-id="element-1197">
            {status === 'locked' ? <Lock className="w-5 h-5" data-id="element-1198" /> : <Icon className="w-5 h-5" data-id="element-1199" />}
          </div>
          <h4 className="font-semibold text-primary text-sm sm:text-base" data-id="element-1200">
            {title}
          </h4>
        </div>
        {status === 'completed' && <CheckCircle className="w-5 h-5 text-turquoise" data-id="element-1201" />}
        {status === 'flagged' && <AlertCircle className="w-5 h-5 text-amber-500" data-id="element-1202" />}
        {status === 'skipped' && <span className="text-xs font-medium uppercase tracking-wider text-secondary" data-id="element-1203">
            Skipped - Not applicable
          </span>}
      </div>
      {status !== 'locked' && <div className="space-y-3 pl-8 sm:pl-12" data-id="element-1204">
          {children}
          {status === 'completed' && onViewLegal && <button onClick={onViewLegal} className="text-xs text-violetBlue font-medium hover:underline mt-2 inline-block" data-id="element-1205">
              View as legal text &rarr;
            </button>}
        </div>}
    </div>;
}